import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotVideos from './components/HotVideos';
import LatestUpdates from './components/LatestUpdates';
import FeaturesGrid from './components/FeaturesGrid';
import Testimonials from './components/Testimonials';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <article>
          <CategoryNav />
          <HotVideos />
          <LatestUpdates />
          <FeaturesGrid />
          <Testimonials />
        </article>
      </main>

      <section className="py-14 bg-background-900 text-center">
        <div className="max-w-2xl mx-auto px-4 md:px-6">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
            准备好开始观看了吗？
          </h2>
          <p className="text-sm text-background-300 mb-6">
            加入5000万+用户的大家庭，免费观看海量高清视频
          </p>
          <a
            href="/category"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line text-lg"></i>
            立即免费观看
          </a>
        </div>
      </section>

      <Footer />
    </>
  );
}